import {
  DownloadStatusPayload,
  DownloadStatus,
  ConstraintType,
  BeforePlayModals
} from '@shared/SPA/UWPNotifier'
import { Milliseconds} from './formatting'

const TWODAYS = new Milliseconds().fromDays(2)
const NOEXPIRATION = 0

export const isLicenseValid = ({LicenseUsableForPlay, LicenseExpirationDate}: DownloadStatusPayload) =>
(LicenseUsableForPlay === true && (LicenseExpirationDate == NOEXPIRATION || LicenseExpirationDate > Date.now()))

export const isLicenseExpiresSoon = (props: DownloadStatusPayload) => (isLicenseValid(props) && props.LicenseExpirationDate != NOEXPIRATION && props.LicenseExpirationDate < (Date.now() + TWODAYS))

export const isShowPlayButton = (props: DownloadStatusPayload) => (props.Status === DownloadStatus.COMPLETED && (!props.NeedsLicense || (props.NeedsLicense && isLicenseValid(props))))

const modalSelector = (props: DownloadStatusPayload) => {
  let modal = undefined
  
  // Priority to rental modal
  modal = props.Modals.find(modal => modal.Type === ConstraintType.RENTAL)
  
  // Then license offline modal
  if(!modal){
    modal = props.Modals.find(modal => modal.Type === ConstraintType.OFFLINE)
  }
  
  return modal
}

export const isShowModalBeforePlay = (props: DownloadStatusPayload): BeforePlayModals => {
  if(props.Modals && props.Modals.length > 0) {
    return modalSelector(props)
  }
}
